export const HOUR_FORMAT = 'HH:00';
export const GROUP_HOUR_FORMAT = 'dd-MM-yyyy-HH';
export const GROUP_DATE_FORMAT = 'dd-MM-yyyy';

export const ITEM_INFO_HEIGHT = 32;
export const DEFAULT_CELL_HEIGHT = 84;

export const DISPLAY_HOURS = 9;
